import { useEffect, useState } from 'react';
import useMeetData from '@usas/ui-web/state/meet/UseMeetData';
import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';

const useMeetInfo = () => {
  const { meetState, putMeet } = useMeetData();
  const { securityState } = useSecurityData();
  const [simpleFormState, setSimpleFormState] = useState(getInitialFormState());
  const taxonomies = securityState?.userInfo?.taxonomies || [];
  const normalize = (s) => (s || '').trim().toLowerCase();
  
  const containsDisplayName = (items, target) =>
    Array.isArray(items) && items.some((item) =>
      normalize(item?.displayName) === normalize(target)
      || containsDisplayName(item?.children, target)
    );
  
  const hasHqLscManagement = taxonomies.some((taxonomy) =>
    normalize(taxonomy?.displayName) === 'hq lsc management'
    || containsDisplayName(taxonomy?.taxonomyLinks, 'HQ LSC Management')
  );

  function createPUTObject() {
    const copyMeet = JSON.parse(JSON.stringify(meetState.objData));

    return {
      ...copyMeet,
      isUploadLocked: simpleFormState.isUploadLocked
    };
  }

  const onSaveClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (meetState.isObjLoaded === true) {
      putMeet(meetState.objData.meetId, -1, '', '', createPUTObject());
    }
  }

  const onSimpleFormValueChanged = (component, value) => {
    setSimpleFormState({ ...simpleFormState, [component]: value })
  }

  useEffect(() => {
    if (meetState.isObjLoaded === true && meetState.isSaving === false) {
      setSimpleFormState({
        ...simpleFormState,
        isUploadLocked: meetState.objData.isUploadLocked
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetState]);

  function getInitialFormState() {
    return {
      isUploadLocked: false
    };
  }

  return {
    meetState,
    simpleFormState,
    hasHqLscManagement,
    onSimpleFormValueChanged,
    onSaveClicked,
    futureMeet: new Date(meetState.objData.startDate) > new Date()
  }
}

export default useMeetInfo;